import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import { NotificationProvider } from './components/Notifications/NotificationProvider';
import AuthPage from './pages/AuthPage';
import AdminPage from './pages/AdminPage';
import RegisterPage from './pages/RegisterPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SetupUsernamePage from './pages/SetupUsernamePage';
import AccountSettingsPage from './pages/AccountSettingsPage';
import AboutPage from './pages/AboutPage';
import HowToPage from './pages/HowToPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ConsentBanner from './components/ConsentBanner';
import reportWebVitals from './reportWebVitals';

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.NODE_ENV
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const path = window.location.pathname;
let Element: React.ReactElement;
if (path === '/login') {
  Element = <AuthPage />;
} else if (path === '/register') {
  Element = <RegisterPage />;
} else if (path === '/setup-username') {
  Element = <SetupUsernamePage />;
} else if (path === '/admin') {
  Element = <AdminPage />;
} else if (path === '/reset-password') {
  Element = <ResetPasswordPage />;
} else if (path === '/settings' || path === '/account-settings') {
  Element = <AccountSettingsPage />;
} else if (path === '/about') {
  Element = <AboutPage />;
} else if (path === '/how-to') {
  Element = <HowToPage />;
} else if (path === '/terms') {
  Element = <TermsPage />;
} else if (path === '/privacy') {
  Element = <PrivacyPage />;
} else {
  Element = <App />;
}

root.render(
  <React.StrictMode>
    <NotificationProvider>
      <>
        {Element}
        <ConsentBanner />
      </>
    </NotificationProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
